import { CopilotMessages, CopilotInput } from '@/features/copilot';
import { Box } from '@customerio/pluma-components/react';
import { PageTitle } from '@/components/page-title';
import { AgentLayout } from './layout';
import * as styles from './index.css';

export default function Agent() {
  return (
    <>
      <PageTitle title="Agent" />
      <AgentLayout>
        <Box display="flex" flexDirection="column" flexGrow="1" h="0" w="full" className={styles.fullscreenChat}>
          <CopilotMessages />
          <Box className={`${styles.contentContainer} ${styles.inputCard}`} p="100">
            <CopilotInput />
          </Box>
        </Box>
      </AgentLayout>
    </>
  );
}
